// Lightweight notification chime using the Web Audio API (no asset files).
// Safe to call on any new-message event; browsers allow it after the user has
// interacted with the page (opening the chat / logging into admin counts).

let _ctx = null;

const getCtx = () => {
  if (typeof window === 'undefined') return null;
  try {
    if (!_ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      _ctx = new AC();
    }
    if (_ctx.state === 'suspended') _ctx.resume().catch(() => {});
    return _ctx;
  } catch {
    return null;
  }
};

// Pleasant two-note "ding-dong" chime.
export const playChime = () => {
  const ctx = getCtx();
  if (!ctx) return;
  try {
    const now = ctx.currentTime;
    const master = ctx.createGain();
    master.gain.value = 0.0001;
    master.connect(ctx.destination);

    const notes = [
      { f: 880, t: 0.0 },   // A5
      { f: 1174.7, t: 0.14 }, // D6
    ];
    notes.forEach(({ f, t }) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = f;
      const start = now + t;
      g.gain.setValueAtTime(0.0001, start);
      g.gain.exponentialRampToValueAtTime(0.28, start + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, start + 0.42);
      osc.connect(g);
      g.connect(master);
      osc.start(start);
      osc.stop(start + 0.45);
    });
    master.gain.setValueAtTime(0.9, now);
  } catch {
    /* ignore */
  }
};
